import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

import { getBetListing, getOptionData } from "../../../store/ducks/event/betListing/actions";
import { filterErrorHandler } from "../../../hoc/Shared/utility";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import EventBetListing from "./EventBetListing";
import Swal from "sweetalert2";
import moment from "moment";
import TransactionDetails from '../../Transaction/TransactionDetails';

const initialInputState =
{
    /* form input value */
    team: '',
    date: moment().subtract(6,'d').format('yyyy/MM/DD')+" 12:00:00 AM - "+moment().format("yyyy/MM/DD hh:mm:ss A"),
    start_date: moment().subtract(6,'d').format('yyyy/MM/DD')+" 12:00:00 AM",
    end_date: moment().format('yyyy/MM/DD hh:mm:ss A'),
};

class EventBet extends Component {
    /* ======================== Component Lifecycle [START] ======================== */
    constructor(props) {
        super(props);

        this.state = {
            pageShow: "listing",

            /* datatables / pagination */
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            totalPages: 0,
            totalRecords: 0,
            searchValue: "",
            search: "",

            /* API result array */
            data: [],

            /* popup box */
            popupLoading: false,

            settingID: null,
            loading: true,

            permission: [],

            filter: initialInputState,
            dropdown: {
                team: [],
                status: []
            }
        };
    }

    componentDidMount() {
        const listingArr = this.getFilterArray();
        this.props.getBetListing(listingArr);
        this.props.getOptionData();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            this.setState({ permission: this.props.currentPermission });
        }

        if (nextProps.rs !== this.props.rs && nextProps.rs !== undefined) {
            if(nextProps.rs.data.responseCode === 200 && nextProps.rs.data.msgType === 'success') {
                let rowDataArray = [];
                nextProps.rs.data.data.result.row.map((val) => {
                    rowDataArray[val.id] = val;
                    return null;
                });

                this.setState({
                    data: nextProps.rs.data.data.result.row,
                    totalRecords: nextProps.rs.data.data.result.pagination.total_record,
                    totalPages: nextProps.rs.data.data.result.pagination.total_page,
                    rowDataArray: rowDataArray,
                    loading: false
                });
            } else {
                this.setState({
                    activePage: 1,
                    totalRecords: 0,
                    data: [],
                    loading: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.rs.data.message);
                });
            }
        }
        
        if (nextProps.dropdown !== this.props.dropdown && nextProps.dropdown !== undefined) {
            if(nextProps.dropdown.data.responseCode === 200 && nextProps.dropdown.data.msgType === 'success') {
                let teamOption = [];

                if (nextProps.dropdown.data.data.team !== undefined) {
                    nextProps.dropdown.data.data.team.map((val) => {
                        teamOption.push({
                            label: t('world_cup.'+val),
                            value: val
                        });
                        return null;
                    });
                }
                
                let statusDropdown = [];
                statusDropdown.push({label: t('global.active'),value: "1"});
                statusDropdown.push({label: t('global.inactive'),value: "0"});

                this.setState({
                    dropdown: {
                        team: teamOption,
                        status: statusDropdown
                    },
                    loading: false,
                });
            } else {
                this.setState({
                    loading: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.dropdown.data.message);
                });
            }
            
        }

        return true;
    }
    /* ======================== Component Lifecycle [END] ======================== */
    onInputChange(event) {
        // console.log(event.target.id+' | '+event.target.value);
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;
        if(event.target.id==='date')
        {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }

        this.setState({
            filter: newFilter
        });
    }

    loadingHandler = () => {
        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    };

    refreshHandler = () => {
        this.setState({
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: null,
        }, ()=> {
            const listingArr = this.getFilterArray();
            this.props.getBetListing(listingArr);
        });
    }

    changePageHandler = (page) => {
        this.setState({
            pageShow: page,
            popupLoading: true,
        });
    };

    getFilterArray = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.country_id = this.props.currentUser.country_id;
        Object.keys(this.state.filter).forEach((val) =>
        {
            listingArr[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });

        return listingArr;
    }
    /* ======================== Function [END] ======================== */

    /* ======================== Datatables Function [START] ======================== */
    datatablesChangeHandler = (val, act) => {
        this.setState(
            {
                [act]: act === "searchValue" ? val.target.value : val,
                loading: true,
                data: [],
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.getBetListing(listingArr);
            }
        );
    };

    clearHandler = () => {
        let newFilter = initialInputState;
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            searchValue: '',
            filter: newFilter,
            loading: true,
            data: [],
        }, ()=>
        {
            const listingArr = this.getFilterArray();
            this.props.getBetListing(listingArr);
        });
    }

    detailsHandler = (e, page, id) => {
        e.preventDefault();
        this.setState({
            pageShow: page,
            detailsParam :
            {
                id: id
            }
        });
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = order === "asc" ? true : false;

        orderArry[0]["id"] = field;
        orderArry[0]["desc"] = orderSequence;

        this.setState(
            {
                order: orderArry,
                loading: true,
                data: [],
                // errMsg: [],
                // touched: false,
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.getBetListing(listingArr);
            }
        );
    };

    noFormatter = (cell, row, rowIndex) => {
        //let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
        let rowNumber = this.state.totalRecords - rowIndex - (this.state.activePage - 1) * this.state.limit;
        return <span>{rowNumber}</span>;
    };

    orderIDFormatter = (cell,row) => {
        let orderIdVal = "";
        let permission = this.props.currentUser.permission ? this.props.currentUser.permission : [];
        
        orderIdVal = permission.includes("transaction_details_access") && row.order_id ? (
            <b>
                <a
                    href="/#"
                    onClick={(event) => 
                        this.detailsHandler(event, 'details', row.transaction_id)
                    }
                >
                    {row.order_id}
                    <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
                </a>
            </b>
        ) : (
            (row.order_id || '-')
        );

        return orderIdVal;
    }

    searchChangeHandler = (event) => {
        this.setState({ searchValue: event.target.value });
    };

    onSearchKeyPressHandler = (event) => {
        //Checking press the enter only perform search action
        if (event.key === "Enter") {
            this.setState({ loading: true, data: [], activePage: 1 }, () => {
                const listingArr = this.getFilterArray();
                this.props.getBetListing(listingArr);
            });
        }
    };

    /* ============ Datatables Function [END] ============ */

    render() {
        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <EventBetListing
                        filter={this.state.filter}
                        onInputChange={(event) => this.onInputChange(event)}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        refreshHandler={this.refreshHandler}
                        clearHandler={this.clearHandler}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        data={this.state.data}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        searchValue={this.state.searchValue}
                        searchChangeHandler={this.searchChangeHandler}
                        searchPressSubmitHandler={(event) => this.onSearchKeyPressHandler(event)}
                        loading={this.state.loading}
                        permission={this.state.permission}
                        dropdown={this.state.dropdown}
                        onSort={this.onSort}

                        noFormatter={this.noFormatter}
                        orderIDFormatter={this.orderIDFormatter}
                    />
                )}

                {this.state.pageShow==='details' &&
                    <TransactionDetails
                        detailsParam={this.state.detailsParam}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        returnPage='listing'
                        currentUser={this.props.currentUser}
                    />
                }
            </Auxiliary>
        );
    }
}

// Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    return {
        rs: state.eventBetListing.rs,
        dropdown: state.eventBetListing.option_data,
        currentPermission: state.currentUser.data.permission,
        currentUser: state.currentUser.data,
    };
};

// Using the redux calling api methods
const mapDispatchToProps = (dispatch) => {
    return {
        getBetListing: (data) => dispatch(getBetListing(data)),
        getOptionData: (data) => dispatch(getOptionData(data))
    };
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(EventBet));
